import { useTranslation } from 'react-i18next';
import { useGetEmailRule, useGetRequiredRule } from '@/hooks';
import { AdminFormFieldsNames } from '../helpers/types';

export const useAdminFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const email = useGetEmailRule({ t });

  return {
    [AdminFormFieldsNames.FIRST_NAME]: [requiredRule],
    [AdminFormFieldsNames.LAST_NAME]: [requiredRule],
    [AdminFormFieldsNames.ROLE]: [requiredRule],
    [AdminFormFieldsNames.EMAIL]: [requiredRule, email],
  };
};
